import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { StoreService } from 'core/services/store.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

// TODO this component maintains compatibility with admin tables and skeletor tables using the "skeletor" attribute, delete when not needed
@Component({
  selector: 'lms-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss']
})
export class SearchFieldComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() skeletor: boolean = false; // TODO flag to maintain compatibility true for skeletor table false for admin old ones
  @Input() skipEncoding?: boolean;
  public searchTerm = new Subject<string>();
  public showFilterRow: boolean = false;
  public term: string = '';
  public listSubscription: Subscription;
  private searching = false;
  private tableDatasource: TableDatasource;

  constructor() {}

  public ngOnInit(): void {
    this.searchTerm.pipe(debounceTime(500), distinctUntilChanged()).subscribe(async (term: string) => {
      this.searching = true;
      if (this.skeletor) {
        await this.tableDatasource.refreshData({
          search: this.skipEncoding ? term : encodeURIComponent(term),
          page: 1
        });
        StoreService.update(this.listId, this.tableDatasource);
        this.searching = false;
      } else {
        StoreService.merge(this.listId, {
          search: this.skipEncoding ? term : encodeURIComponent(term),
          page: 1,
          active: true
        });
      }
    });
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      this.showFilterRow = data && data.showFilterRow;
      if (this.skeletor) {
        this.tableDatasource = data;
      }

      if (this.searching) {
        this.searching = false;
      } else if ((!this.term && data && data.search) || this.showFilterRow) {
        setTimeout(() => (this.term = data.search ? decodeURIComponent(data.search) : ''));
      }
    });
  }

  public ngOnDestroy(): void {
    this.listSubscription.unsubscribe();
    this.searchTerm.unsubscribe();
  }

  public search(value: string): void {
    this.term = value ? value : '';
    this.searchTerm.next(this.term);
  }
}
